import React,{useEffect, useState} from 'react';
import {TituloMenu,ColFlex, RowStyle, DivPedidoContenido} from './style'
import {Row, Col, List, Card, DatePicker, Input, Button, Tag, Icon, Drawer} from 'antd'
import { useSelector, useDispatch } from 'react-redux'; 
import { actionGetHistorialOrdenes, actionGetOrden, actionRevisarOrden } from '../../store/acciones/accionesOrdenes';
import {Link} from 'react-router-dom'
import useWindowSize from '../../assets/js/use-windows-size';
import NumberFormat from 'react-number-format';
import CONSTANTES from '../../store/constantes';
import RevisarOrden from './forms/RevisarOrden';

const { MonthPicker} = DatePicker;
const { Search } = Input;

const Historial = (props) => {
    const size = useWindowSize();
    const [visibleSider, showSider]=useState(false)
   //const [dataOrden, getDataOrden]=useState()
    const [isMobile, windowResize]=useState(false)
    let historialOrdenes = useSelector(state => state.reducerOrdenes.historial);
    let detailOrden = useSelector(state => state.reducerOrdenes.orden);

    const[fecha, setfecha]=useState()

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actionGetHistorialOrdenes());
        windowResize({isMobile:size.width<=360?true:false})
    }, [dispatch, size.width]);


    const openFormOrden=(orden)=>{
        dispatch(actionGetOrden(orden.id));
        showSider(true)
    }

    const editarOrden=(values)=>{
         setTimeout(() => {
            dispatch(actionRevisarOrden(values))
            showSider(false)
         }, 1000);
    }

    function onChange(date, dateString) {
        console.log(dateString)
        setfecha(dateString)
        dispatch(actionGetHistorialOrdenes(null, dateString))
      }

    let filterHistorial = e => {
        dispatch(actionGetHistorialOrdenes(e.target.value, fecha))
    }
    return (
        <>
            <TituloMenu>Historial de Ordenes</TituloMenu>
            {/* ---------------------------Filtros de Ordenes----------------------------- */}
            <RowStyle type="flex" justify="space-around" align="middle">
                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    {fecha?<Search placeholder="Numero de orden, cliente " onChange={e => filterHistorial(e)} enterButton />:
                    <div>Para buscar una orden en especifico debes seleccionar  una fecha</div>
                    }
                    
                </ColFlex>
                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <MonthPicker onChange={onChange} placeholder="Seleccionar Mes" />
                </ColFlex>
            </RowStyle>

            <Row type="flex" justify="space-around" align="middle">
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <List
                     pagination={{
                        pageSize: 10,
                      }}
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 1,
                            lg: 1,
                            xl: 1,
                            xxl: 2,
                        }}
                        dataSource={historialOrdenes}
                        renderItem={item => (
                            <List.Item>
                                <Card title={item.cliente.NOMBRE}>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                                            <DivPedidoContenido>
                                                <p>Numero de orden: <span>{item.numerodeorden}</span></p> 
                                                <p>Fecha: <span>{item.fechageneracion}</span></p>
                                                <p>Total: <span><NumberFormat value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} fixedDecimalScale={true}  decimalScale={2} /></span></p>
                                                
                                            </DivPedidoContenido>
                                        </Col>
                                        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                                            <DivPedidoContenido>
                                                <p>Status: <span >{
                                                    item.status==='g'?<Tag color="green"><Icon type="heat-map" style={{ fontSize: '20px' }} /> Generada</Tag>:
                                                    item.status==='a'?<Tag color="geekblue"><Icon type="fire" style={{ fontSize: '20px' }} /> Aprobada</Tag>:
                                                    item.status==='c'?<Tag color="red"><Icon type="minus-circle" style={{ fontSize: '20px' }} /> <strike>Cancelada</strike></Tag>:
                                                    item.status==='v'?<Tag color="orange"><Icon type="bank" style={{ fontSize: '20px' }} /> Validada</Tag>:
                                                    item.status==='s'?<Tag color="#075e54"><Icon type="like" style={{ fontSize: '20px' }} /> Surtida Completa</Tag>:
                                                    item.status==='i'?<Tag color="volcano"><Icon type="issues-close" style={{ fontSize: '20px' }} /> Incompleto el Surtido</Tag>:
                                                <Tag color="cyan">Hay un error</Tag>}
                                                            </span></p>
                                            </DivPedidoContenido>    
                                        </Col>
                                        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                                        <Link to={`${props.match.url}/${item.id}`} ><Button>Ver</Button></Link>
                                        <Button href={`${CONSTANTES.URL_API}/pedidos/pdf/${item.id}/`} target="blank" >Descargar PDF</Button>
                                        <Button onClick={() => openFormOrden(item)}>Revisar</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </List.Item>
                        )}
                    />
                </Col>
                <Drawer
                    title="Panel de aprobación"
                    placement="right"
                    closable={false}
                    onClose={() => showSider(false)}
                    visible={visibleSider}
                    width={isMobile.isMobile ? "90%" : "40%"}
                    destroyOnClose
                    switchscrollingEffect
                >
                    <RevisarOrden registro={editarOrden} data={detailOrden} />

                </Drawer>
            </Row>
        </>
    );
};

export default Historial;